import httpDriver from 'app/utils/httpDriver';
import { TMutation, TQuery } from 'app/Requests/types';
import { apiRoutes } from 'notifications/utils/apiRoutes';

export const queryName = async (): Promise<any> => {
  const { data } = await httpDriver.get('');
  return data;
};

export const requestName = async (): Promise<any> => {
  const { data } = await httpDriver.post('');
  return data;
};

export const getAllModulesActions = async ({}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.modulesActions);
  return data.payload.records;
};

export const userActionsUpdate = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.userActionsUpdate, body);
  return data;
};

export const notificationRead = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.loadNotificationRead, body);
  return data;
};

export const loadAllNotificationsData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.allNotifications,
    queryKey[1]
  );
  return data.payload;
};

export const getNotificationsCount = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.NotificationsCount,
    queryKey[1]
  );
  return data.payload?.records;
};
export const makeNotificationSeen = async (
  body: TMutation<any>
): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.makeNotificationsSeen, body);
  return data;
};

export const getAlertNotificationsInApp = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.NotificationsInApp,
    queryKey[1]
  );
  return data.payload?.records;
};
